<div class="filter">
    <div class="filter-header">
        <div class="filter-header-title">{{ "FILTER" | translate }}</div>

        <div class="filter-header-container">
            <button
                mat-button
                color="primary"
                [disabled]="filterForm.invalid"
                (click)="requestKpi()"
            >
                <fa-icon icon="check"></fa-icon>
                {{ "APPLY" | translate }}
            </button>
            <button mat-button color="primary" (click)="clearForm()">
                <fa-icon icon="undo"></fa-icon>
                {{ "CLEAR" | translate }}
            </button>
            <button
                mat-button
                color="primary"
                (click)="displayOrHideFiltersPanel()"
            >
                <fa-icon
                    [ngClass]="{ rotate: !displayFiltersPanel }"
                    class="animation-rotate"
                    icon="angle-down"
                ></fa-icon>
                {{
                    (displayFiltersPanel ? "VIEW_LESS" : "VIEW_MORE")
                        | translate
                }}
            </button>
        </div>
    </div>
    <form
        class="filter-form"
        [formGroup]="filterForm"
        [@detailExpand]="displayFiltersPanel ? 'expanded' : 'collapsed'"
    >
        <div class="filter-form-container">
            <mat-form-field
                appearance="outline"
                class="filter-form-container-field"
            >
                <mat-label>{{ "ASSET_FAMILY" | translate }}</mat-label>
                <mat-select formControlName="family">
                    <mat-option>
                        <ngx-mat-select-search
                            [placeholderLabel]="'SEARCH' | translate"
                            [formControl]="searchForm.controls.family"
                            [noEntriesFoundLabel]="
                                'NO_OPTIONS_FOUND' | translate
                            "
                        >
                        </ngx-mat-select-search>
                    </mat-option>
                    <mat-option>
                        <i>-- {{ "CLEAR_SELECTION" | translate }} --</i>
                    </mat-option>
                    @for (
                        family of families$
                            | async
                            | listFilter
                                : "name"
                                : searchForm.value.family
                                : true
                                : true
                            | sort: false : "name";
                        track family
                    ) {
                        <mat-option [value]="family.id">
                            {{ family.name }}
                        </mat-option>
                    }
                </mat-select>
                @if ((loadings.families$ | async) === true) {
                    <mat-hint>
                        <mat-progress-spinner
                            mode="indeterminate"
                            diameter="12"
                            strokeWidth="2"
                        ></mat-progress-spinner>
                        {{ "LOADING_DATA" | translate }}
                    </mat-hint>
                }
                @if (
                    (loadings.families$ | async) === false &&
                    filterForm.controls.family.errors?.required
                ) {
                    <mat-error>
                        <fa-icon icon="circle-exclamation"></fa-icon>
                        {{ "REQUIRED_SELECTION" | translate }}
                    </mat-error>
                }
            </mat-form-field>

            <mat-form-field
                appearance="outline"
                class="filter-form-container-field"
            >
                <mat-label>{{ "START_ZONE" | translate }}</mat-label>
                <mat-select formControlName="zone">
                    <mat-option>
                        <ngx-mat-select-search
                            [placeholderLabel]="'SEARCH' | translate"
                            [formControl]="searchForm.controls.zone"
                            [noEntriesFoundLabel]="
                                'NO_OPTIONS_FOUND' | translate
                            "
                        >
                        </ngx-mat-select-search>
                    </mat-option>
                    <mat-option>
                        <i>-- {{ "CLEAR_SELECTION" | translate }} --</i>
                    </mat-option>
                    @for (
                        zone of zones$
                            | async
                            | listFilter
                                : "name"
                                : searchForm.value.zone
                                : true
                                : true
                            | sort: false : "name";
                        track zone
                    ) {
                        <mat-option [value]="zone.id">
                            {{ zone.name }}
                        </mat-option>
                    }
                </mat-select>
                @if ((loadings.zones$ | async) === true) {
                    <mat-hint>
                        <mat-progress-spinner
                            mode="indeterminate"
                            diameter="12"
                            strokeWidth="2"
                        ></mat-progress-spinner>
                        {{ "LOADING_DATA" | translate }}
                    </mat-hint>
                }
                @if (
                    (loadings.zones$ | async) === false &&
                    filterForm.controls.zone.errors?.required
                ) {
                    <mat-error>
                        <fa-icon icon="circle-exclamation"></fa-icon>
                        {{ "REQUIRED_SELECTION" | translate }}
                    </mat-error>
                }
            </mat-form-field>

            <mat-form-field
                appearance="outline"
                class="filter-form-container-field"
            >
                <mat-label>{{ "PASSAGE_ZONE" | translate }}</mat-label>
                <mat-select formControlName="passzone">
                    <mat-option>
                        <ngx-mat-select-search
                            [placeholderLabel]="'SEARCH' | translate"
                            [formControl]="searchForm.controls.passZone"
                            [noEntriesFoundLabel]="
                                'NO_OPTIONS_FOUND' | translate
                            "
                        >
                        </ngx-mat-select-search>
                    </mat-option>
                    <mat-option>
                        <i>-- {{ "CLEAR_SELECTION" | translate }} --</i>
                    </mat-option>
                    @for (
                        zone of zones$
                            | async
                            | listFilter
                                : "name"
                                : searchForm.value.passZone
                                : true
                                : true
                            | sort: false : "name";
                        track zone
                    ) {
                        <mat-option [value]="zone.id">
                            {{ zone.name }}
                        </mat-option>
                    }
                </mat-select>
                @if ((loadings.zones$ | async) === true) {
                    <mat-hint>
                        <mat-progress-spinner
                            mode="indeterminate"
                            diameter="12"
                            strokeWidth="2"
                        ></mat-progress-spinner>
                        {{ "LOADING_DATA" | translate }}
                    </mat-hint>
                }
                @if (
                    (loadings.zones$ | async) === false &&
                    filterForm.controls.passzone.errors?.required
                ) {
                    <mat-error>
                        <fa-icon icon="circle-exclamation"></fa-icon>
                        {{ "REQUIRED_SELECTION" | translate }}
                    </mat-error>
                }
            </mat-form-field>

            <mat-form-field
                appearance="outline"
                class="filter-form-container-field"
            >
                <mat-label>{{ "IN_OUT_ZONE_FILTER" | translate }}</mat-label>
                <mat-select formControlName="inOutzone">
                    <mat-option>
                        <ngx-mat-select-search
                            [placeholderLabel]="'SEARCH' | translate"
                            [formControl]="searchForm.controls.inOutzone"
                            [noEntriesFoundLabel]="
                                'NO_OPTIONS_FOUND' | translate
                            "
                        >
                        </ngx-mat-select-search>
                    </mat-option>
                    <mat-option>
                        <i>-- {{ "CLEAR_SELECTION" | translate }} --</i>
                    </mat-option>
                    @for (
                        zone of zones$
                            | async
                            | listFilter
                                : "name"
                                : searchForm.value.inOutzone
                                : true
                                : true
                            | sort: false : "name";
                        track zone
                    ) {
                        <mat-option [value]="zone.id">
                            {{ zone.name }}
                        </mat-option>
                    }
                </mat-select>
                @if ((loadings.zones$ | async) === true) {
                    <mat-hint>
                        <mat-progress-spinner
                            mode="indeterminate"
                            diameter="12"
                            strokeWidth="2"
                        ></mat-progress-spinner>
                        {{ "LOADING_DATA" | translate }}
                    </mat-hint>
                }
                @if (
                    (loadings.zones$ | async) === false &&
                    filterForm.controls.inOutzone.errors?.required
                ) {
                    <mat-error>
                        <fa-icon icon="circle-exclamation"></fa-icon>
                        {{ "REQUIRED_SELECTION" | translate }}
                    </mat-error>
                }
            </mat-form-field>

            <mat-form-field
                appearance="outline"
                type="autoComplete"
                class="filter-form-container-field"
            >
                <mat-label>{{ "ASSET_NAME" | translate }} </mat-label>
                <mat-select formControlName="assets" multiple>
                    <mat-select-trigger>
                        {{
                            assets$
                                | async
                                | listFilter
                                    : "id"
                                    : filterForm.value.assets?.[0]
                                | extractPropertyPipe: "name"
                        }}
                        @if (filterForm.value.assets?.length > 1) {
                            <small>
                                <br />+ {{ filterForm.value.assets.length - 1 }}
                                {{ "OPTIONS_SELECTED" | translate }}
                            </small>
                        }
                    </mat-select-trigger>
                    <mat-option>
                        <ngx-mat-select-search
                            [placeholderLabel]="'SEARCH' | translate"
                            [formControl]="searchForm.controls.asset"
                            [noEntriesFoundLabel]="
                                'NO_OPTIONS_FOUND' | translate
                            "
                            [showToggleAllCheckbox]="true"
                            [toggleAllCheckboxChecked]="
                                assetsOptions
                                    | listSelectionCheckboxState
                                        : filterForm.controls.assets.value
                                        : ListSelectionState.all
                            "
                            [toggleAllCheckboxIndeterminate]="
                                assetsOptions
                                    | listSelectionCheckboxState
                                        : filterForm.controls.assets.value
                                        : ListSelectionState.partial
                            "
                            (toggleAll)="toggleAllAssets($event)"
                        >
                        </ngx-mat-select-search>
                    </mat-option>
                    @for (
                        asset of assets$
                            | async
                            | listFilter
                                : "name"
                                : searchForm.value.asset
                                : true
                                : true
                            | sort: false : "name";
                        track asset
                    ) {
                        <mat-option [value]="asset.id">
                            {{ asset.name }}
                        </mat-option>
                    }
                </mat-select>
                @if ((loadings.assets$ | async) === true) {
                    <mat-hint>
                        <mat-progress-spinner
                            mode="indeterminate"
                            diameter="12"
                            strokeWidth="2"
                        ></mat-progress-spinner>
                        {{ "LOADING_DATA" | translate }}
                    </mat-hint>
                }
                @if (
                    (loadings.assets$ | async) === false &&
                    filterForm.controls.assets.errors?.required
                ) {
                    <mat-error>
                        <fa-icon icon="circle-exclamation"></fa-icon>
                        {{ "REQUIRED_SELECTION" | translate }}
                    </mat-error>
                }
            </mat-form-field>

            <mat-form-field appearance="outline">
                <mat-label>{{ "DATETIME_RANGE" | translate }}</mat-label>
                <mat-date-range-input [rangePicker]="picker">
                    <input
                        readonly
                        matStartDate
                        formControlName="startDate"
                        placeholder="{{ 'START_DATE' | translate }}"
                    />
                    <input
                        readonly
                        matEndDate
                        formControlName="endDate"
                        placeholder="{{ 'END_DATE' | translate }}"
                    />
                </mat-date-range-input>
                <mat-datepicker-toggle
                    matSuffix
                    [for]="picker"
                ></mat-datepicker-toggle>
                <mat-date-range-picker #picker></mat-date-range-picker>
                @if (
                    filterForm.controls.startDate.errors?.required ||
                    filterForm.controls.endDate.errors?.required
                ) {
                    <mat-error>
                        <fa-icon icon="circle-exclamation"></fa-icon>
                        {{ "REQUIRED_SELECTION" | translate }}
                    </mat-error>
                }
            </mat-form-field>
        </div>
    </form>
</div>

<span id="kpi-filter-clear-value" style="display: none">{{
    "CLEAR_SELECTION" | translate
}}</span>
